import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, Phone } from "lucide-react";
import { Logo } from "../components/Logo";
import { usePaymentStatus } from "../hooks/usePaymentStatus";

const Spinner = () => <Loader2 className="mx-auto animate-spin text-gold-dark" size={28} />;

const MESSAGES = {
  checking: { icon: <Spinner />, text: "Vérification de votre paiement…" },
  paid: {
    icon: (
      <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gold/15 text-gold-dark">
        <CheckCircle2 size={26} />
      </span>
    ),
    title: "Merci !",
    text: "Votre paiement est confirmé. Nous revenons vers vous très vite pour démarrer votre projet. Un email de confirmation vient de vous être envoyé.",
  },
  pending: {
    icon: <Spinner />,
    title: "Paiement en cours de confirmation",
    text: "Cela peut prendre quelques minutes. En cas de doute, appelez-nous.",
  },
  error: {
    title: "Nous n'avons pas pu vérifier le paiement",
    text: "Si vous avez été débité, tout est enregistré de notre côté — contactez-nous au téléphone ci-dessous pour confirmer.",
  },
};

const StatusMessage = ({ state }) => {
  const m = MESSAGES[state];
  return (
    <div className="mt-10">
      {m.icon}
      {m.title && <h1 className="mt-5 font-display text-2xl font-bold text-navy">{m.title}</h1>}
      <p className="mt-3 text-sm leading-relaxed text-slate-600" data-testid="payment-status">{m.text}</p>
    </div>
  );
};

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const state = usePaymentStatus(params.get("session_id"));

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream px-4" data-testid="payment-success-page">
      <div className="w-full max-w-md rounded-3xl border border-navy/10 bg-white p-10 text-center shadow-xl shadow-navy/10">
        <div className="flex justify-center">
          <Logo />
        </div>
        <StatusMessage state={state} />
        <div className="mt-8 flex flex-col items-center gap-3 border-t border-navy/10 pt-6">
          <a data-testid="payment-success-phone" href="tel:+33784678802" className="flex items-center gap-2 text-sm font-semibold text-navy transition-colors hover:text-gold-dark">
            <Phone size={15} /> 07 84 67 88 02
          </a>
          <Link data-testid="payment-success-home" to="/" className="text-sm font-medium text-slate-500 transition-colors hover:text-navy">
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
}
